import { configureStore } from "@reduxjs/toolkit";
import providerReducer from "./Slice/providerSlice"; 
import customerReducer from "./Slice/customerSlice";

export const store = configureStore({
  reducer: {
    providers: providerReducer,
    customer: customerReducer,
  },
});
